export const toolsValidationSchema = {
  tool: {
    required: "Seleziona uno strumento",
  },
  sensorType: {
    required: "Seleziona una tipologia di sensore",
  },
  devEui: {
    required: "Inserisci un dev EUI",
    pattern: {
      value: /^[A-Fa-f0-9]{16}$/,
      message: "Dev EUI deve essere di 16 caratteri esadecimali",
    },
  },
  appEui: {
    required: "Inserisci un' app EUI",
    pattern: {
      value: /^[A-Fa-f0-9]{16}$/,
      message: "App EUI deve essere di 16 caratteri esadecimali",
    },
  },
  appKey: {
    required: "Inserisci un' app KEY",
    pattern: {
      value: /^[A-Fa-f0-9]{32}$/,
      message: "App KEY deve essere di 32 caratteri esadecimali",
    },
  },
  frequencyUpdate: {
    required: "Seleziona una frequenza di aggiornamento",
  },
  gatewayName: {
    required: "Inserisci un nome",
  },
  gatewayEui: {
    required: "Inserisci un EUI",
    pattern: {
      value: /^[A-Fa-f0-9]{16}$/,
      message: "Gateway EUI deve essere di 16 caratteri esadecimali",
    },
  },
  brand: {
    required: "La marca è obbligatoria",
  },
  model: {
    required: "Il modello è obbligatorio",
  },
};

const getApiErrorMessage = (error) => error?.error?.message || "";
const getApiLocalizedError = (error) => error?.error?.localized_error || "";

export const isDevEuiDuplicateError = (error) => {
  const message = getApiErrorMessage(error);
  const normalizedMessage = message.toLowerCase();

  if (!message) return false;

  return (
    message === "devEUI already exists" ||
    getApiLocalizedError(error) === "invalid_devEUI" ||
    (normalizedMessage.includes("deveui") &&
      (normalizedMessage.includes("already exists") ||
        normalizedMessage.includes("duplicate") ||
        normalizedMessage.includes("unique")))
  );
};

export const isGatewayEuiDuplicateError = (error) => {
  const message = getApiErrorMessage(error);
  const normalizedMessage = message.toLowerCase();

  if (!message) return false;

  return (
    normalizedMessage.includes("instruments_gateway_deveui") &&
    (normalizedMessage.includes("already exists") ||
      normalizedMessage.includes("duplicate") ||
      normalizedMessage.includes("unique"))
  );
};

export const isAssignedFieldReferenceError = (error) => {
  const normalizedMessage = getApiErrorMessage(error).toLowerCase();

  return (
    normalizedMessage.includes("assigned_field_id") &&
    normalizedMessage.includes("foreign key")
  );
};
